var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map",
    viewBox: "0 0 19 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.06 0.25C0.02 0.33 0 0.41 0 0.49V13.41C0 13.6 0.1 13.77 0.27 13.85L6.23 16.83C6.37 16.9 6.54 16.9 6.67 16.83L12.41 13.96L18.15 16.83C18.23 16.87 18.32 16.88 18.39 16.88C18.47 16.88 18.56 16.85 18.63 16.81C18.78 16.72 18.87 16.56 18.87 16.39V3.48C18.87 3.29 18.77 3.12 18.6 3.04L12.64 0.06C12.5 -0.01 12.34 -0.01 12.2 0.06L6.46 2.92L0.71 0.05C0.64 0.01 0.56 0 0.47 0C0.39 0 0.31 0.03 0.23 0.07C0.16 0.12 0.1 0.18 0.06 0.25ZM12.91 1.29L17.88 3.78V15.59L12.91 13.1V1.29ZM6.95 3.78L11.92 1.29V13.1L6.95 15.59V3.78ZM0.99 1.29L5.96 3.78V15.59L0.99 13.1V1.29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4bc695a9c3810d96ee2fe66e6521e985.svg";
export { ForwardRef as ReactComponent };